<template>
    <div>
        <header>
            <div class="bloque-cabecera">
                <!-- <div class="logo"></div> -->
            </div>
        </header>
        <br />

        <section>
            <div class="bloque-datos">
                <v-row justify="center">
                    <v-col align="center" class="col-12">
                        <menuPage></menuPage>
                    </v-col>
                </v-row>
                <div class="bloque-datos-titulo">
                    <p class="justifyLeft">
                        Para poder atenderte en caso de incidencia con tu dispositivo reacondicionado necesitamos que cumplimentes el siguiente formulario.
                    </p>
                    <p class="justifyLeft">
                        Ten presente los campos obligatorios (*).
                    </p>
                    <!--<p class="justifyLeft" style="font-family: Heebo; font-weight: normal">
                        Para reparar tu dispositivo, necesitamos que rellenes los datos que te solicitamos a continuación (los marcados con (*) son obligatorios).
                    </p>
                    <p class="justifyLeft" style="font-family: Heebo; font-weight: normal">
                        En un plazo máximo de 48 horas laborables desde que nos envíes, contactaremos contigo para ir a recoger tu dispositivo.
                    </p>
                    <p class="justifyLeft" style="font-family: Heebo; font-weight: normal">
                        La recogida y devolución del dispositivo no tienen costes asociados y la reparación, si tu dispositivo está en garantía, tampoco.
                    </p>
                    <p class="justifyLeft" style="font-family: Heebo; font-weight: normal">
                        En caso de no estar en garantía, te facilitaremos un presupuesto.
                    </p>-->
                </div>
                <br />

                <div class="bloque-alerta">
                    <span id="lblMensaje" style="color: #869296; font-family: Heebo; font-weight: normal"></span>
                </div>
                <br />
                <div class="bloque-datos-campos">
                    <v-alert v-if="incidencia != ''"
                             dense
                             outlined
                             prominent
                             text
                             :type="tipoTextoIncidencia"
                             style="font-family: Heebo; font-weight: normal">
                        {{ incidencia }}
                    </v-alert>
                    <h2 style="font-family: Heebo; font-weight: normal">1. Datos de contacto</h2>
                    <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">(*) Nombre y apellidos: </div>
                    <div class="row-campos">
                        <input v-model="formulario.metaData.nombreCliente"
                               name="txtNombre"
                               maxlength="40"
                               id="txtNombre"
                               tabindex="3"
                               class="text-datos"
                               type="text" />
                        <span id="lblMensaje3"
                              style="color: #ff0000; font-family: Heebo; font-weight: normal"
                              v-html="erroresObligatorios.nombre"></span>
                    </div>
                    <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">(*) DNI/CIF/TARJETA RESIDENTE/PASAPORTE</div>
                    <div class="row-campos">
                        <input v-model="localDNI"
                               name="txtDNI"
                               type="text"
                               id="txtDNI"
                               @change="checkIncidenciaRepetida()"
                               tabindex="14"
                               class="text-datos"
                               style="color: #6f737d; font-family: Heebo; font-weight: normal" />
                        <span id="lblMensaje14"
                              style="color: #ff0000; font-family: Heebo; font-weight: normal"
                              v-html="errorDNI"></span>
                    </div>
                    <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">Cliente: </div>
                    <div class="row-campos">
                        <input v-model="localAbonado"
                               name="txtAbonado"
                               maxlength="9"
                               id="txtAbonado"
                               tabindex="2"
                               class="text-datos"
                               type="tel" />
                        <span id="lblMensaje2"
                              style="color: #ff0000; font-family: Heebo; font-weight: normal"
                              v-html="errorAbonado"></span>
                    </div>
                    <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">(*) Teléfono de Contacto:</div>
                    <div class="row-campos">
                        <input v-model="localTelefono"
                               name="txtTelefono"
                               maxlength="9"
                               id="txtTelefono"
                               tabindex="1"
                               class="text-datos"
                               type="tel" />
                        <span id="lblMensaje1"
                              style="color: #ff0000; font-family: Heebo; font-weight: normal"
                              v-html="errorTelefono"></span>
                    </div>
                    <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">(*) Email:</div>
                    <div class="row-campos">
                        <input v-model="localEmail"
                               name="txtEmail"
                               maxlength="60"
                               id="txtEmail"
                               tabindex="4"
                               class="text-datos"
                               type="email" />
                        <span id="lblMensaje4"
                              style="color: #ff0000; font-family: Heebo; font-weight: normal"
                              v-html="errorEmail"></span>
                    </div>
                    <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">(*) Dirección:</div>
                    <div class="row-campos">
                        <input v-model="formulario.metaData.direccionCliente"
                               name="txtDireccion"
                               maxlength="80"
                               id="txtDireccion"
                               tabindex="6"
                               class="text-datos"
                               type="text"
                               style="color: #6f737d; font-family: Heebo; font-weight: normal" />
                        <span id="lblMensaje6"
                              style="color: #ff0000; font-family: Heebo; font-weight: normal"
                              v-html="erroresObligatorios.direccion"></span>
                    </div>
                    <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">(*) Código Postal:</div>
                    <div class="row-campos">
                        <input v-model="formulario.metaData.cpCliente"
                               name="txtCodpos"
                               maxlength="7"
                               id="txtCodpos"
                               tabindex="7"
                               class="text-datos"
                               type="number"
                               style="color: #6f737d; font-family: Heebo; font-weight: normal" />
                        <span id="lblMensaje7"
                              style="color: #ff0000; font-family: Heebo; font-weight: normal"
                              v-html="erroresObligatorios.cp"></span>
                    </div>
                    <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">(*) Población:</div>
                    <div class="row-campos">
                        <input v-model="formulario.metaData.poblacionCliente"
                               name="txtPoblacion"
                               maxlength="40"
                               id="txtPoblacion"
                               tabindex="8"
                               class="text-datos"
                               type="text"
                               style="color: #6f737d; font-family: Heebo; font-weight: normal" />
                        <span id="lblMensaje8"
                              style="color: #ff0000; font-family: Heebo; font-weight: normal"
                              v-html="erroresObligatorios.poblacion"></span>
                    </div>
                    <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">
                        <h3 style="font-family: Heebo; font-weight: normal">Horario de Contacto</h3><br />(Cuando contactemos tiene que tener
                        acceso al dispositivo)
                    </div>
                    <span id="lblMensaje9"
                          style="color: #ff0000"
                          v-html="erroresObligatorios.horarioContacto"></span>
                    <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">(*) Horario desde:</div>
                    <div class="row-campos">
                        <v-autocomplete dense
                                        clearable
                                        auto-select-first
                                        v-model="localHorarioDesde"
                                        :items="itemsHorariosDesde"
                                        name="txtHoraDesde"
                                        id="txtHoraDesde"
                                        tabindex="17"
                                        style="color: #6f737d"></v-autocomplete>
                    </div>
                    <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">(*) Horario hasta:</div>
                    <div class="row-campos">
                        <v-autocomplete v-if="localHorarioDesde !== '' && localHorarioDesde !== undefined"
                                        dense
                                        clearable
                                        auto-select-first
                                        v-model="localHorarioHasta"
                                        :items="itemsHorariosHasta"
                                        name="txtHoraDesde"
                                        id="txtHoraDesde"
                                        tabindex="17"
                                        style="color: #6f737d"></v-autocomplete>
                        <v-autocomplete v-else
                                        dense
                                        clearable
                                        auto-select-first
                                        v-model="localHorarioHasta"
                                        :items="[]"
                                        name="txtHoraDesde"
                                        id="txtHoraDesde"
                                        tabindex="17"
                                        style="color: #6f737d"></v-autocomplete>
                    </div>
                    <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">
                        Si quieres que tengamos en cuenta cualquier cuestión antes de ponernos en contacto contigo, por favor, indícanoslo aquí:
                    </div>
                    <div class="row-campos">
                        <v-textarea auto-grow
                                    counter
                                    :maxlength="200"
                                    outlined
                                    v-model="observacionesContacto"></v-textarea>
                    </div>
                    <div class="row-etiqueta"><h2 style="font-family: Heebo; font-weight: normal">2. Resumen de la avería</h2></div>
                    <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal"> <b>(*) Por favor, indícanos brevemente qué le pasa a tu dispositivo:</b></div>
                    <div class="row-campos">
                        <input v-model="formulario.linea.sintomaAveria"
                               name="txtSintoma"
                               id="txtSintoma"
                               tabindex="5"
                               class="text-datos"
                               type="email" />
                        <span id="lblMensaje5"
                              style="color: #ff0000; font-family: Heebo; font-weight: normal"
                              v-html="erroresObligatorios.sintoma"></span>
                    </div>

                    <br />
                    <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">(*) Justificante de compra (Albarán, Factura, …):</div>
                    <div class="row-campos">
                        <input-file v-model="formulario.albaran" />
                        <span id="lblMensaje2"
                              style="color: #ff0000; font-family: Heebo; font-weight: normal"
                              v-html="erroresObligatorios.albaran"></span>
                    </div>
                    <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">Número de Serie</div>
                    <div class="row-campos">
                        <input v-model="formulario.metaData.sn"
                               name="txtSN"
                               maxlength="20"
                               id="txtSN"
                               @change="checkIncidenciaRepetida()"
                               tabindex="9"
                               class="text-datos"
                               type="text"
                               style="color: #6f737d; font-family: Heebo; font-weight: normal" />
                        <div style="display: inline; margin-left: -30px; padding-bottom: 30px">
                            <img @click="modalSN = true"
                                 src="/img/formulario Rent 2 Rent/ico_ayuda.png"
                                 alt="?" />
                        </div>
                    </div>
                    <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">(*) IMEI</div>
                    <div class="row-campos">
                        <input v-model="formulario.metaData.imei"
                               name="txtIMEI"
                               maxlength="20"
                               id="txtIMEI"
                               @change="checkIncidenciaRepetida()"
                               tabindex="10"
                               class="text-datos"
                               type="text"
                               style="color: #6f737d; font-family: Heebo; font-weight: normal" />
                        <div style="display: inline; margin-left: -30px; padding-bottom: 30px">
                            <img @click="modalIMEI = true"
                                 src="/img/formulario Rent 2 Rent/ico_ayuda.png"
                                 alt="?" />
                        </div>
                        <span id="lblMensaje9"
                              style="color: #ff0000; font-family: Heebo; font-weight: normal"
                              v-html="erroresObligatorios.imei"></span>
                    </div>
                    <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">Familia:</div>
                    <div class="row-campos">
                        <div class="select">
                            <select v-if="TiposModelos != null"
                                    v-model="pedirDesplegables.idTipoModelo"
                                    name="cmbTipoModelo"
                                    id="cmbTipoModelo"
                                    :disabled="TiposModelos.length == 1"
                                    tabindex="11">
                                <option v-for="tipoModelo in TiposModelos"
                                        :key="tipoModelo.ID"
                                        selected
                                        :value="tipoModelo.ID">
                                    {{ tipoModelo.DESCRIPCION }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <template v-if="pedirDesplegables.idTipoModelo !== null">
                        <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">Marca:</div>
                        <div v-if="pedirDesplegables.idTipoModelo != 1" class="row-campos">
                            <div class="select">
                                <select v-if="Fabricantes != null"
                                        v-model="pedirDesplegables.idMarca"
                                        name="cmbMarca"
                                        id="cmbMarca"
                                        @change="changeSelectMarca"
                                        tabindex="12">
                                    <option v-for="fabricante in Fabricantes"
                                            :key="fabricante.ID"
                                            :value="fabricante.ID">
                                        {{ fabricante.DESCRIPCION }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </template>
                    <div v-else class="row-campos">
                        <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">Marca:</div>
                        <input v-model="formulario.metaData.marca"
                               name="txtMARCA"
                               type="text"
                               id="txtMARCA"
                               tabindex="14"
                               class="text-datos"
                               style="color: #6f737d; font-family: Heebo; font-weight: normal" />
                    </div>
                    <template v-if="pedirDesplegables.idMarca !== null">
                        <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">Modelo:</div>
                        <div v-if="pedirDesplegables.idTipoModelo != 1" class="row-campos">
                            <div class="select">
                                <select v-if="Modelos != null"
                                        v-model="formulario.idModelo"
                                        name="cmbModelo"
                                        id="cmbModelo"
                                        tabindex="13">
                                    <option v-for="modelo in Modelos"
                                            :key="modelo.ID"
                                            :value="modelo.ID">
                                        {{ modelo.DESCRIPCION }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </template>
                    <div v-else class="row-campos">
                        <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">Modelo:</div>
                        <input v-model="formulario.metaData.modelo"
                               name="txtMODELO"
                               type="text"
                               id="txtMODELO"
                               tabindex="14"
                               class="text-datos"
                               style="color: #6f737d; font-family: Heebo; font-weight: normal" />
                    </div>
                    <div class="row-etiqueta" style="font-family: Heebo; font-weight: normal">Color:</div>
                    <div class="row-campos">
                        <input v-model="formulario.metaData.color"
                               name="txtCOLOR"
                               type="text"
                               id="txtCOLOR"
                               tabindex="14"
                               class="text-datos"
                               style="color: #6f737d;font-family: Heebo; font-weight: normal" />
                    </div>
                    <br /><br />
                          <div class="requerimiento">
                              <label style="font-family: Heebo; font-weight: normal">
                                  Este es un <strong>formulario específico</strong> para el caso en
                                  que quiera <strong>reparar su dispositivo Reacondicionado</strong>.
                              </label><br /><br />
                              <label style="font-family: Heebo; font-weight: normal">
                                  Si el <strong>equipo esta defectuoso en origen </strong>por un fallo funcional, debe
                                  realizar la solicitud dentro de los primeros 15 días desde la
                                  adquisición de su dispositivo y debe presentar el dispositivo en
                                  su embalaje original con todos los accesorios y manuales.
                              </label><br /><br />
                              <label style="font-family: Heebo; font-weight: normal; background-color:yellow">
                                  Solo se tramitarán reparaciones cubiertas por la garantía durante la vigencia de ésta, excluyendo daños ocasionados por mal uso del dispositivo.
                              </label><br /><br />
                              <!-- <label style="font-family: Heebo; font-weight: normal">
        <strong>* Deberá llamar al 1004</strong> Si el dispositivo se ha
        <strong>dañado en el transporte</strong> o quiere
        <strong>desistir de la compra realizada</strong> y devolver el
        equipo, y solicitar la tramitación de un desistimiento.
    </label><br /><br />
    <label style="font-family: Heebo; font-weight: normal">
        * Solo aplica para entregas en domicilio del cliente.
    </label>-->
                          </div>
                    <br />
                    <br />
                    <v-btn @click="comprobarCampos" color="#9be51a" x-large block>
                        <span style="color: black; font-weight: bold; font-family: Heebo">ENVIAR</span>
                    </v-btn>


                    <!--<v-btn @click="comprobarCampos" color="#9be51a" x-large block>
        <span style="color:black; font-weight:bold">LEER Y ACEPTAR CONDICIONES</span>
    </v-btn>-->
                    <br />
                    <br />
                    <div class="form-row">
                        <div class="controls mb-1">
                            <input id="leer" type="checkbox" v-model="formulario.metaData.leer">
                            <a href="/doc/CondicionesWebZLR_AtencionAverias.pdf" target="_blank">
                                <span style="color:black; font-weight:bold">LEER Y ACEPTAR CONDICIONES   </span>
                            </a>

                        </div>
                    </div>
                    <span id="lblMensaje9"
                          style="color: #ff0000; font-family: Heebo; font-weight: normal"
                          v-html="errorLeerCondiciones"></span>


                </div>
            </div>

            <!-- MODALES -->
            <v-dialog v-model="modalSN" max-width="800">
                <v-card>
                    <v-img src="/img/formulario Rent 2 Rent/SN.jpg"></v-img>
                </v-card>
            </v-dialog>

            <v-dialog v-model="modalIMEI" max-width="800">
                <v-card>
                    <v-img src="/img/formulario Rent 2 Rent/ejemplo Imei2.png"></v-img>
                </v-card>
            </v-dialog>
        </section>

        <footer>
            <div style="height: 30px"></div>
            <div class="bloque-alerta">
                <span id="lblMensaje12"></span>
            </div>
        </footer>
    </div>
</template>

<script>
    import incidencia_formulario from "@/Modelos/IncidenciaFormulario";
    import comprobaciones from "@/plugins/comprobaciones.js";

    export default {
        layout: "movistar",
        components: {
            inputFile: () => import("@/components/fusion/input-file"),
            menuPage: () => import("@/components/reacondicionados/menu"),
        },
        created() {
            this.formulario = incidencia_formulario;
            this.formulario.idOrigen = 4
            this.getDesplegables();
        },

        data: () => ({
            //Iniciales
            TiposModelos: undefined,
            Fabricantes: undefined,
            Modelos: undefined,
            modalSN: false,
            modalIMEI: false,
            modalCondiciones: false,
            //Flujo
            pedirDesplegables: {
                idTipoModelo: null,
                idMarca: null,
            },
            localTelefono: "",
            errorTelefono: "",
            localAbonado: "",
            errorAbonado: "",
            localEmail: "",
            errorEmail: "",
            localDNI: "",
            dniCliente:"",
            errorDNI: "",
            localHorario: "",
            observacionesContacto: "",
            localHorarioDesde: "",
            localHorarioHasta: "",
            erroresObligatorios: {
                nombre: "",
                sintoma: "",
                direccion: "",
                cp: "",
                poblacion: "",
                albaran: "",
                imei: "",
                //familia: "",
                //marca: "",
                //modelo: "",
                horarioContacto: ""
                
            },
            //Final
            formulario: {},
            enviandoIncidencia: false,
            consultandoIncidencia: false,
            incidencia: "",
            tipoTextoIncidencia: "",

            itemsHorariosDesde: ['8:00', '8:30', '9:00', '9:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00'],
            itemsHorariosHasta: ['8:00', '8:30', '9:00', '9:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00'],
        }),


        watch: {
            pedirDesplegables: {
                deep: true,
                handler(valor) {
                    this.getDesplegables();
                },
            },
            localHorarioHasta(nuevo) {
                if (nuevo != "" && this.localHorarioDesde != "")
                    this.formulario.metaData.horarioContacto = "Desde " + this.localHorarioDesde + " hasta " + nuevo;
            },
            localHorarioDesde(nuevo) {
                this.localHorarioHasta = "";
                if (nuevo == undefined && nuevo == "") {
                    this.localHorarioHasta = "";
                } else {
                    Object.assign(this.itemsHorariosHasta, this.itemsHorariosDesde);
                    this.itemsHorariosHasta = this.itemsHorariosHasta.splice(this.itemsHorariosDesde.indexOf(nuevo) + 1, this.itemsHorariosDesde.length);
                }
            }
        },

        computed: {
            formularioCompleto() {
                return (
                    this.formulario.metaData.telefonoCliente != null &&
                    this.formulario.metaData.telefonoCliente != "" &&
                    //this.formulario.metaData.numeroAbonadoCliente != null &&
                    //this.formulario.metaData.numeroAbonadoCliente != "" &&
                    this.formulario.metaData.dniCliente != null &&
                    this.formulario.metaData.dniCliente != "" &&
                    this.formulario.metaData.nombreCliente != null &&
                    this.formulario.metaData.nombreCliente != "" &&
                    this.formulario.metaData.emailCliente != null &&
                    this.formulario.metaData.emailCliente != "" &&
                    this.formulario.linea.sintomaAveria != null &&
                    this.formulario.linea.sintomaAveria != "" &&
                    this.formulario.metaData.direccionCliente != null &&
                    this.formulario.metaData.direccionCliente != "" &&
                    this.formulario.metaData.cpCliente != null &&
                    this.formulario.metaData.cpCliente != "" &&
                    this.formulario.metaData.poblacionCliente != null &&
                    this.formulario.metaData.poblacionCliente != "" &&
                    this.formulario.metaData.horarioContacto != null &&
                    this.formulario.metaData.horarioContacto != "" &&
                    this.formulario.albaran.base64 != null &&
                    this.formulario.albaran.base64 != "" &&
                    this.formulario.albaran.nombre != null &&
                    this.formulario.albaran.nombre != "" &&
                    this.formulario.metaData.imei != null &&
                    this.formulario.metaData.imei != "" &&
                    //this.pedirDesplegables.idTipoModelo != null &&
                    //this.pedirDesplegables.idTipoModelo != "" &&
                    //this.pedirDesplegables.idMarca != null &&
                    //this.pedirDesplegables.idMarca != "" &&
                    //this.formulario.idModelo != null &&
                    //this.formulario.idModelo != "" &&
                    this.formulario.metaData.leer == true

                );
            },
        },

        methods: {
            getDesplegables() {
                this.$API.getDesplegables(this.pedirDesplegables).then((response) => {
                    if (response.hasOwnProperty("tiposModelos")) {
                        this.TiposModelos = response.tiposModelos;
                        if (response.tiposModelos.length == 1)
                            this.pedirDesplegables.idTipoModelo = response.tiposModelos[0].ID;
                    }
                    if (response.hasOwnProperty("marcas"))
                        this.Fabricantes = response.marcas;
                    if (response.hasOwnProperty("modelos")) this.Modelos = response.modelos;
                });
            },

            changeSelectMarca() {

                if (this.pedirDesplegables.idTipoModelo == 1 && this.pedirDesplegables.idMarca == 77) {
                    if (window.confirm('Para poder recogerse el dispositivo tiene que estar desactivada la función Buscar Mi iPhone. Si necesita ayuda, pulse aceptar para leer el documento')) {
                        window.open('/doc/Desactivar_Buscar_iPhone_2020.pdf', '_blank');
                    };
                }

            },

            checkIncidenciaRepetida() {
     
                if (!this.consultandoIncidencia) {
                    this.incidencia = "";
                    this.consultandoIncidencia = true;
                    this.formulario.metaData.dniCliente = this.localDNI;
                    let datos = {
                        formulario: this.formulario,
                        familia: this.pedirDesplegables.idTipoModelo,

                    }
                    this.$API.consultarIncidencia(datos).then((response) => {
                        if (response.codigo == 0) {
                            if (response.idincidencia != 0) {
                                alert('Ya existe una incidencia abierta con esos datos. Se ha enviado un email a la cuenta que la ha creado con las instrucciones para consultarla. Incidencia: ' + response.incidencia);
                                //this.tipoTextoIncidencia = "warning";
                                //this.incidencia = response.mensaje;
                            } else {
                               // this.tipoTextoIncidencia = "success";
                               // this.incidencia = "Ya existe una incidencia abierta con esos datos. Se ha enviado un email a la cuenta que la ha creado con las instrucciones para consultarla. Incidencia: " + responseData.incidencia;
                                
                            }
                            // this.vaciarCampos();
                        } else {
                            //this.tipoTextoIncidencia = "warning";
                            //this.incidencia = "Ha habido un error al consultar la incidencia. Por favor, intentelo de nuevo más tarde";
                        }
                        window.scrollTo(0, 0);
                        this.consultandoIncidencia = false;
                        this.modalCondiciones = false;
                    });
                }
            },

            //Validaciones de campos
            comprobarCampos() {
                this.comprobarCheckLeerCondiciones();
                this.comprobarTelefono();
                //this.comprobarAbonado();
                this.comprobarDNI();
                this.comprobarEmail();
                this.comprobarObligatorios();

                if (!this.formularioCompleto) window.scrollTo(0, 0);
                else this.enviar()
            },
            comprobarCheckLeerCondiciones() {
                this.errorLeerCondiciones = "";
                if (this.formulario.metaData.leer != true)
                    this.errorLeerCondiciones =
                        "Debe confirmar que se han leído y aceptado las condiciones.";
            },
            comprobarDNI() {
                let comprobacionesjs = new comprobaciones();
                this.formulario.metaData.dniCliente = "";
                this.errorDNI = "";
                if (this.localDNI == "")
                    this.errorDNI = "El campo <b>'DNI'</b> es obligatorio y no puede estar vacío";
                else if (!comprobacionesjs.isDNI(this.localDNI) && !comprobacionesjs.isNIE(this.localDNI) && !comprobacionesjs.isCIF(this.localDNI) && !comprobacionesjs.isTR(this.localDNI) && !comprobacionesjs.isPassport(this.localDNI))
                    this.errorDNI = "El campo <b>'DNI/CIF/TARJETA RESIDENTE/PASAPORTE'</b> no tiene un formato correcto.";
                else this.formulario.metaData.dniCliente = this.localDNI;
            },
            comprobarAbonado() {
                this.formulario.metaData.numeroAbonadoCliente = "";
                this.errorAbonado = "";
                if (this.localAbonado == "")
                    this.errorAbonado = "El campo <b>'Número de Abonado'</b> es obligatorio y no puede estar vacío";
                else if (!/^[0-9]{9}/.test(this.localAbonado))
                    this.errorAbonado = "El campo <b>'Número de Abonado'</b> no tiene un formato correcto, 9 dígitos númericos sin espacios";
                else this.formulario.metaData.numeroAbonadoCliente = this.localAbonado;
            },
            comprobarTelefono() {
                this.formulario.metaData.telefonoCliente = "";
                this.errorTelefono = "";
                if (this.localTelefono == "")
                    this.errorTelefono =
                        "El campo <b>'Teléfono de Contacto'</b> es obligatorio y no puede estar vacío";
                else if (!/^[0-9]{9}/.test(this.localTelefono))
                    this.errorTelefono =
                        "El campo <b>'Teléfono de Contacto'</b> no tiene un formato correcto, 9 dígitos númericos sin espacios";
                else this.formulario.metaData.telefonoCliente = this.localTelefono;
            },
            comprobarEmail() {
                this.formulario.metaData.emailCliente = "";
                this.errorEmail = "";
                if (this.localEmail == "")
                    this.errorEmail = "El campo <b>'Email'</b> es obligatorio y no puede estar vacío";
                else if (!this.localEmail.includes("@") || !this.localEmail.includes("."))
                    this.errorEmail = "El campo <b>'Email'</b> no tiene un formato de email válido";
                else this.formulario.metaData.emailCliente = this.localEmail;
            },
            comprobarObligatorios() {
                Object.entries(this.erroresObligatorios).forEach(([key, value]) => {
                    this.erroresObligatorios[key] = "";
                });
                if (this.formulario.metaData.nombreCliente == null || this.formulario.metaData.nombreCliente == "")
                    this.erroresObligatorios.nombre = "El campo <b>'Nombre'</b> es obligatorio y no puede estar vacío";
                if (this.formulario.linea.sintomaAveria == null || this.formulario.linea.sintomaAveria == "")
                    this.erroresObligatorios.sintoma = "El campo <b>'Síntoma de la Avería'</b> es obligatorio y no puede estar vacío";
                if (this.formulario.metaData.direccionCliente == null || this.formulario.metaData.direccionCliente == "")
                    this.erroresObligatorios.direccion = "El campo <b>'Dirección'</b> es obligatorio y no puede estar vacío";
                if (this.formulario.metaData.cpCliente == null || this.formulario.metaData.cpCliente == "")
                    this.erroresObligatorios.cp = "El campo <b>'Código Postal'</b> es obligatorio y no puede estar vacío";
                if (this.formulario.metaData.poblacionCliente == null || this.formulario.metaData.poblacionCliente == "")
                    this.erroresObligatorios.poblacion = "El campo <b>'Población'</b> es obligatorio y no puede estar vacío";
                if (this.formulario.metaData.horarioContacto == null || this.formulario.metaData.horarioContacto == "")
                    this.erroresObligatorios.horarioContacto = "Los campos <b>'HORARIO DESDE'</b> y <b>'HORARIO HASTA'</b> son obligatorios y no pueden estar vacíos";
                if (this.formulario.albaran.base64 == null || this.formulario.albaran.base64 == "" || this.formulario.albaran.nombre == null || this.formulario.albaran.nombre == "")
                    this.erroresObligatorios.albaran = "El campo <b>'Albarán'</b> es obligatorio y no puede estar vacío";
                if (this.formulario.metaData.imei == null || this.formulario.metaData.imei == "")
                    this.erroresObligatorios.imei = "El campo <b>'Imei'</b> es obligatorio y no puede estar vacío";

                //if (
                //    this.pedirDesplegables.idTipoModelo == null ||
                //    this.pedirDesplegables.idTipoModelo == ""
                //)
                //    this.erroresObligatorios.familia = "El campo <b>'Familia'</b> es obligatorio y no puede estar vacío"

                //if (
                //    this.pedirDesplegables.idMarca == null ||
                //    this.pedirDesplegables.idMarca == ""
                //)
                //    this.erroresObligatorios.marca = "El campo <b>'Marca'</b> es obligatorio y no puede estar vacío"

                //if (
                //    this.formulario.idModelo == null ||
                //    this.formulario.idModelo == ""
                //)
                //    this.erroresObligatorios.modelo = "El campo <b>'Modelo'</b> es obligatorio y no puede estar vacío"
            },

            //envio final
            async enviar() {
                var encontrado = 0;
                this.formulario.metaData.dniCliente = this.localDNI;
                let datos2 = {
                    formulario: this.formulario,
                    familia: this.pedirDesplegables.idTipoModelo,

                }
                await this.$API.consultarIncidencia(datos2).then((response2) => {

                    if (response2.codigo == 0) {
 
                        if (response2.idincidencia != 0) { 
                            encontrado = 1;
                            //alert('Ya existe una incidencia abierta con esos datos. Se ha enviado un email a la cuenta que la ha creado con las instrucciones para consultarla. Incidencia: ' + response2.incidencia);
                            this.tipoTextoIncidencia = "warning";
                            this.incidencia = 'Ya existe una incidencia abierta con esos datos. Se ha enviado un email a la cuenta que la ha creado con las instrucciones para consultarla. Incidencia: ' + response2.incidencia;
                            window.scrollTo(0, 0);
                        } else {
                            // this.tipoTextoIncidencia = "success";
                            // this.incidencia = "Ya existe una incidencia abierta con esos datos. Se ha enviado un email a la cuenta que la ha creado con las instrucciones para consultarla. Incidencia: " + responseData.incidencia;
       
                        }
                        // this.vaciarCampos();
                    } else {
                        //this.tipoTextoIncidencia = "warning";
                        //this.incidencia = "Ha habido un error al consultar la incidencia. Por favor, intentelo de nuevo más tarde";
                    }
                    
                });

         
                if (!this.enviandoIncidencia && encontrado==0) {
                    this.incidencia = "";
                    this.enviandoIncidencia = true;
                    this.formulario.metaData.dniCliente = this.localDNI;
                    this.$API.resgistarIncidencia({
                            formulario: this.formulario,
                            familia: this.pedirDesplegables.idTipoModelo,
                        })
                        .then((response) => {
                            if (response.codigo == 0) {
                                if (response.incidencia === undefined) {
                                    this.tipoTextoIncidencia = "warning";
                                    this.incidencia = response.mensaje;
                                } else {
                                    this.tipoTextoIncidencia = "success";
                                    this.incidencia =
                                        "Se ha generado la incidencia '" +
                                        response.incidencia +
                                        "' para tratar su gestión";
                                }
                                this.vaciarCampos();
                            } else {
                                this.tipoTextoIncidencia = "warning";
                                this.incidencia =
                                    "Ha habido un error al crear la incidencia. Por favor, intentelo de nuevo más tarde";
                            }
                            window.scrollTo(0, 0);
                            this.enviandoIncidencia = false;
                            this.modalCondiciones = false;
                        });
                }


               
            },
            vaciarCampos() {
                this.localTelefono = "";
                this.localAbonado = "";
                this.localEmail = "";
                this.pedirDesplegables.idTipoModelo = null;
                this.pedirDesplegables.idMarca = null;
                this.formulario = incidencia_formulario;
            },
        },
    };
</script>

<style>
    .informacion {
        color: #869296;
        font-size: 20px;
    }

    .informacion:hover {
        color: rgb(78, 168, 0);
    }

    .condiciones .azulClaro {
        color: #A6DDFB;
    }
    .condiciones .azul {
        color: #019DF4;
    }
    .condiciones ul {
        padding-left: 20px;
        padding-bottom: 10px;
        list-style: none;
    }
    .condiciones ul li::before {
        content: "\2022";
        color: #019DF4;
        font-weight: bold;
        display: inline-block;
        width: 1em;
        margin-left: -1em;
    }
</style>